import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Modal } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const ImageModal = ({ open, onClose, imageUrl }) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    backgroundColor: "rgba(100, 100, 100, 0.8)",
                    position: "relative",
                }}
            >
                <IconButton
                    onClick={onClose}
                    style={{
                        position: "absolute",
                        top: 16,
                        right: 16,
                        color: "#FFFFFF",
                        zIndex: 1000,
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <img
                    src={imageUrl}
                    alt="Preview"
                    style={{ maxWidth: "90%", maxHeight: "90%" }}
                />
            </Box>
        </Modal>
    );
};

ImageModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    imageUrl: PropTypes.string.isRequired,
};

export default ImageModal;
